export default __webpack_public_path__ + "static/lgbtq-pr-sj-1-fa36b7acad40100476f1272dfee4b40a.jpg";